import styled from 'styled-components';

export const TaskCreationFieldsLayout = styled.div`
  display: grid;
  grid-gap: 8px;
  grid-template-columns: 200px 1fr;
  align-items: center;
  justify-content: flex-start;
  padding-bottom: 24px;
  border-bottom: 1px solid #e0deda;
`;
